import React, { useState, useEffect, useRef } from 'react';
import { sanitizeInput } from '@core/utils/dompurify/dompurify.js';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import {
  getCompaniesByFilterAsyncSelectCreateTask,
  getCompaniesInitialOptionsAsyncSelect,
} from 'FielderUtils/company/company';
import ErrorCodes from 'FielderUtils/ErrorCodes';
import Datetime from 'react-datetime';
import {
  Box,
  Stack,
  Typography,
  TextField,
  Button,
  Alert,
  Chip,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useLanguage } from 'Context/LanguageContext';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Location from '../../components/Location/Location';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import model from 'Object/model/model.js';
import { createBranchRequest, getLastIdsCustomRequest } from '@core/api/branch/branch.service';
import MoreBranchInformation from './MoreBranchInformation';
import moment from 'moment';

let beginningTime = null;
let endTime = null;
let validTime;

const AddBranchOffice = (props) => {
  const lan = useLanguage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const moreBranchInformationRef = useRef({});

  const [idCustom, setIdCustom] = useState('');
  const [name, setName] = useState('');
  const [newDirection, setNewDirection] = useState('');
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [postalCode, setPostalCode] = useState('');
  const [branchState, setBranchState] = useState('');
  const [timeZone, setTimeZone] = useState('');
  const [municipality, setMunicipality] = useState('');
  const [country, setCountry] = useState('');
  const [errorLocation, setErrorLocation] = useState(false);
  const [id, setId] = useState(null);
  const [legalAddress, setLegalAddress] = useState(null);
  const [activateAlert, setActivateAlert] = useState(false);
  const [attentionTimeFrom, setAttentionTimeFrom] = useState(null);
  const [attentionTimeTo, setAttentionTimeTo] = useState(null);
  const [showErrorDuplicateBranch, setShowErrorDuplicateBranch] = useState(false);
  const [lastIdsCustom, setLastIdsCustom] = useState([]);
  const [showMoreBranchInfo, setShowMoreBranchInfo] = useState(false);

  useEffect(() => {
    const onSuccess = (response) => {
      let branches = response.branches;
      if (branches) {
        setLastIdsCustom(branches);
      }
    };
    const onError = (error) => {
      console.log(error);
    };
    const loadingConfig = { name: 'GET_LAST_IDS_CUSTOM', dispatch };
    getLastIdsCustomRequest(onSuccess, onError, loadingConfig);

    if (props.defaultCompany) {
      setId(props.defaultCompany.value.id);
    }
  }, []);

  const getCompanyList = async (event) => {
    if (event.length > 0) {
      let assignList = await getCompaniesByFilterAsyncSelectCreateTask(event);
      return assignList;
    }
  };

  const getInitialOptionsCompany = async () => {
    return await getCompaniesInitialOptionsAsyncSelect();
  };

  const updateLocation = (newLocation, coordinates) => {
    if (coordinates.lat != latitude && coordinates.lng != longitude) {
      setLatitude(coordinates.lat);
      setLongitude(coordinates.lng);
      setNewDirection(newLocation.address);
      setPostalCode(newLocation.postalCode);
      setBranchState(newLocation.state);
      setTimeZone(newLocation.timezone);
      setCountry(newLocation.country);
      setMunicipality(newLocation.municipality);
    }
  };

  const handleOptionSelected = (selectedOption) => {
    if (selectedOption == null) {
      setId(null);
    } else {
      const el = document.getElementById('company-alert-icon');
      if (el) el.style.display = 'none';
      setId(selectedOption.value.id);
    }
  };

  const setValidateName = () => {
    if (name !== '') {
      const nameIcon = document.getElementById('name-alert-icon');
      const nameInput = document.getElementById('name-red-input');
      if (nameIcon) nameIcon.style.display = 'none';
      if (nameInput) nameInput.style.borderColor = '#ced4da';
    }
  };

  const setFieldValue = (value, field) => {
    const sanitizedInput = sanitizeInput(value);
    if (field === 'idCustom') {
      setIdCustom(sanitizedInput);
      const hint = document.getElementById('register-form-hint');
      if (hint) hint.style.display = 'none';
      setShowErrorDuplicateBranch(false);
    } else if (field === 'name') {
      setName(sanitizedInput);
      setValidateName();
      const hint = document.getElementById('register-form-hint');
      if (hint) hint.style.display = 'none';
      setShowErrorDuplicateBranch(false);
    }
  };

  const validateIdCustom = (idCustom) => {
    if (idCustom !== '') {
      const icon = document.getElementById('idCustom-alert-icon');
      const input = document.getElementById('id-input-branch-idCustom');
      if (icon) icon.style.display = 'none';
      if (input) input.style.borderColor = '#ced4da';
      return true;
    }
    const icon = document.getElementById('idCustom-alert-icon');
    const input = document.getElementById('id-input-branch-idCustom');
    if (icon) icon.style.display = 'inline';
    if (input) input.style.borderColor = '#c70101';
    return false;
  };

  const validateName = (name) => {
    if (name !== '') {
      const icon = document.getElementById('name-alert-icon');
      if (icon) icon.style.display = 'none';
      return true;
    }
    const icon = document.getElementById('name-alert-icon');
    const input = document.getElementById('name-red-input');
    if (icon) icon.style.display = 'inline';
    if (input) input.style.borderColor = '#c70101';
    return false;
  };

  const validateCompany = (id) => {
    if (id !== null) {
      const icon = document.getElementById('company-alert-icon');
      if (icon) icon.style.display = 'none';
      return true;
    }
    const icon = document.getElementById('company-alert-icon');
    if (icon) icon.style.display = 'inline';
    return false;
  };

  const validateLocation = () => {
    let isValid = latitude !== 0 && longitude !== 0 && newDirection !== '';
    setErrorLocation(!isValid);
    return isValid;
  };

  const openMoreBranchInfo = () => {
    setShowMoreBranchInfo(!showMoreBranchInfo);
  };

  const handleDoActionAddBranch = (createWithTask) => {
    const isValidName = validateName(name);
    const isValidIdCustom = validateIdCustom(idCustom);
    const isValidIdCompany = validateCompany(id);
    const isValidLocation = validateLocation();

    if (isValidName && isValidIdCustom && isValidLocation && isValidIdCompany && activateAlert === false) {
      let branchInfoPass = {
        parentCompanyId: id,
        idCustom: idCustom,
        name: name,
        state: branchState,
        country: country,
        postalCode: postalCode,
        address: newDirection,
        latitude: latitude,
        longitud: longitude,
        timeZone: timeZone,
        municipality: municipality,
        attentionTimeFrom: attentionTimeFrom,
        attentionTimeTo: attentionTimeTo,
        legalAddress: legalAddress != null && legalAddress != '' ? legalAddress : null,
        createWithDirection: true,
        nameMoreInfo: moreBranchInformationRef.current.name,
        lastNameMoreInfo: moreBranchInformationRef.current.lastName,
        emailMoreInfo: moreBranchInformationRef.current.email,
        cellphoneMoreInfo: moreBranchInformationRef.current.cellphone,
        officePhoneMoreInfo: moreBranchInformationRef.current.officePhone,
        commentMoreInfo: moreBranchInformationRef.current.comment,
      };

      const hint = document.getElementById('register-form-hint');
      if (hint) hint.style.display = 'none';

      let newCompanyInfo = model.doActionCreateBranch(branchInfoPass);
      const body = newCompanyInfo.data;

      const onSuccess = (response) => {
        if (createWithTask == false) {
          if (props.getBranchInformation && response.branch) {
            props.getBranchInformation(response.branch);
          }
          handleClose();
        } else {
          let idBranch = response.idBranch;
          handleClose();
          navigate(`${ENDPOINTS.createTask}?branch=${idBranch}`);
        }
      };

      const onError = (response) => {
        if (response.status === ErrorCodes.DUPLICATED_BRANCH) {
          setShowErrorDuplicateBranch(true);
          const hintEl = document.getElementById('register-form-hint');
          if (hintEl) hintEl.style.display = 'inline';
        } else {
          props.errorMessageCreation();
        }
      };

      const loadingConfig = { name: 'CRATE_BRANCH', dispatch };
      createBranchRequest(body, onSuccess, onError, loadingConfig);
    } else {
      const hint = document.getElementById('register-form-hint');
      if (hint) hint.style.display = 'inline';
    }
  };

  const onChangeTimeOne = (value) => {
    if (value != undefined) {
      let timeFrom = new Date(value._d);
      beginningTime = timeFrom;
      validateTime();
    }
  };

  const onChangeTimeTwo = (value) => {
    if (value != undefined) {
      let timeFromTo = new Date(value._d);
      endTime = timeFromTo;
      validateTime();
    }
  };

  const validateTime = () => {
    if (beginningTime != null && endTime != null) {
      let initialTime = beginningTime;
      let finalTime = endTime;
      validTime = moment(initialTime, 'h:mm a').isBefore(moment(finalTime, 'h:mm a'));
      if (validTime == true) {
        let formatInitialTime = moment(initialTime, 'hh:mm a').format('HH:mm');
        let formatEndTime = moment(finalTime, 'hh:mm a').format('HH:mm');
        setAttentionTimeFrom(formatInitialTime);
        setAttentionTimeTo(formatEndTime);
        setActivateAlert(false);
      } else {
        setActivateAlert(true);
      }
    }
  };

  const handleClose = () => {
    props.setDefaultFalse();
  };

  return (
    <Box sx={{ px: 4, mt: 2, height: '100%' }}>
      {/* ID CUSTOM */}
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Box sx={{ position: 'relative' }}>
          <TextField
            label={lan.idCustomBranch}
            id="id-input-branch-idCustom"
            value={idCustom}
            onChange={(e) => setFieldValue(e.target.value, 'idCustom')}
            size="small"
            fullWidth
          />
          <Box
            component="img"
            src={redAlertIcon}
            alt=""
            id="idCustom-alert-icon"
            sx={{ position: 'absolute', right: -32, top: '50%', transform: 'translateY(-50%)', height: 20, display: 'none' }}
          />
        </Box>
      </Stack>

      {/* LAST IDS CUSTOM */}
      {lastIdsCustom && lastIdsCustom.length > 0 && (
        <Stack spacing={1} sx={{ mb: 4 }}>
          <Typography variant="caption" sx={{ fontSize: 12 }}>
            {lan.lastIdsCustomUsed}
          </Typography>
          <Stack direction="row" flexWrap="wrap" useFlexGap gap={1}>
            {lastIdsCustom.map((data) => (
              <Chip key={data.id} label={data.idCustom} size="small" />
            ))}
          </Stack>
        </Stack>
      )}

      {/* NAME */}
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Box sx={{ position: 'relative' }}>
          <TextField
            label={lan.branchNameText}
            id="name-red-input"
            value={name}
            onChange={(e) => setFieldValue(e.target.value, 'name')}
            size="small"
            fullWidth
          />
          <Box
            component="img"
            src={redAlertIcon}
            alt=""
            id="name-alert-icon"
            sx={{ position: 'absolute', right: -32, top: '50%', transform: 'translateY(-50%)', height: 20, display: 'none' }}
          />
        </Box>
        {showErrorDuplicateBranch && (
          <Alert severity="warning" id="showAlert">{lan.idCustomBranchDuplicated}</Alert>
        )}
      </Stack>

      {/* ATTENTION TIME RANGE */}
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Typography variant="caption" sx={{ fontSize: 12 }}>
          {lan.rangeOfAttentionTime}
        </Typography>
        {activateAlert && (
          <Alert severity="warning" id="showAlert">{lan.hourValidation}</Alert>
        )}
        <Grid container spacing={2} justifyContent="center">
          <Grid size={{ xs:12, sm:6 }}>
            <Datetime
              id="id-date-from"
              inputProps={{ placeholder: lan.from, readOnly: true }}
              dateFormat={false}
              onChange={onChangeTimeOne}
            />
          </Grid>
          <Grid size={{ xs:12, sm:6 }}>
            <Datetime
              id="id-date-to"
              inputProps={{ placeholder: lan.to, readOnly: true }}
              dateFormat={false}
              onChange={onChangeTimeTwo}
            />
          </Grid>
        </Grid>
      </Stack>

      {/* COMPANY SELECT */}
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Typography variant="caption" sx={{ fontSize: 12 }}>
          {lan.companyBranch}
        </Typography>
        <Box sx={{ position: 'relative' }}>
          <AsyncSearch
            id="id-select-branch-company"
            getOptions={(e) => getCompanyList(e)}
            onChange={(e) => handleOptionSelected(e)}
            label={lan.placeHolderCompany}
            showInitialOptions
            getInitialOptions={getInitialOptionsCompany}
            defaultValue={props.defaultCompany ? props.defaultCompany : null}
            styles={{ container: (base) => ({ ...base, width: '100%' }) }}
          />
          <Box
            component="img"
            src={redAlertIcon}
            alt=""
            id="company-alert-icon"
            sx={{ position: 'absolute', right: -32, top: '50%', transform: 'translateY(-50%)', height: 20, display: 'none' }}
          />
        </Box>
      </Stack>

      {/* LOCATION */}
      <Stack spacing={1} sx={{ mt: 3, mb: 4 }}>
        <Typography variant="caption" sx={{ fontSize: 12 }} />
        <Location
          edit
          includeCoordinates
          label={lan.branchLocation}
          locationUpdate={updateLocation}
          error={errorLocation}
          coordinates={{ lat: latitude, lng: longitude }}
        />
      </Stack>

      {/* LEGAL ADDRESS */}
      <Stack spacing={1} sx={{ mt: 2, mb: 4 }}>
        <TextField
          label={lan.legalAddress}
          id="id-input-branch-legalAddress"
          placeholder={lan.legalAddress}
          value={legalAddress ?? ''}
          onChange={(e) => setLegalAddress((value) => sanitizeInput(e.target.value))}
          size="small"
          fullWidth
        />
      </Stack>

      {/* MORE INFO */}
      <Grid container spacing={1} alignItems="center">
        <Grid size={12}>
          <Typography
            variant="body2"
            onClick={openMoreBranchInfo}
            sx={{ textDecoration: 'underline', color: 'primary.main', cursor: 'pointer' }}
          >
            {lan.moreInformation}
          </Typography>
        </Grid>
        <Grid size={12}>
          <MoreBranchInformation
            showMoreBranchInfo={showMoreBranchInfo}
            ref={moreBranchInformationRef}
            nameValue={null}
            lastNameValue={null}
            emailValue={null}
            cellphoneValue={null}
            officePhoneValue={null}
            legalAddressValue={null}
            editData={true}
          />
        </Grid>
      </Grid>

      {/* REQUIRED HINT */}
      <Box id="register-form-hint" sx={{ mt: 4, display: 'none', textAlign: 'center' }}>
        <Typography variant="body2">*{lan.requiredFields}</Typography>
      </Box>

      {/* ACTIONS */}
      <Grid container spacing={2} sx={{ mb: 3, mt: 5 }}>
        <Grid size={{ xs:12, sm:6 }} display="flex" justifyContent="center">
          <Button
            id="id-input-branch-add-button"
            variant="outlined"
            color="primary"
            onClick={() => handleDoActionAddBranch(false)}
            sx={{ width: 271, height: 56 }}
          >
            {lan.addBranch}
          </Button>
        </Grid>
        {props.showCreateBranchWithTask && (
          <Grid size={{ xs:12, sm:6 }} display="flex" justifyContent="center">
            <Button
              id="id-input-branch-add-button"
              variant="outlined"
              color="primary"
              onClick={() => handleDoActionAddBranch(true)}
              sx={{ width: 271, height: 56 }}
            >
              {lan.addBranchAndCreateTask}
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
export default AddBranchOffice;
//Original code:
/*import React, { useState, useEffect, useRef } from 'react';
import { sanitizeInput } from '@core/utils/dompurify/dompurify.js';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import {
	getCompaniesByFilterAsyncSelectCreateTask,
	getCompaniesInitialOptionsAsyncSelect,
} from 'FielderUtils/company/company';
import ErrorCodes from 'FielderUtils/ErrorCodes';
import Datetime from 'react-datetime';
import { Chip } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Location from '../../components/Location/Location';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import model from "Object/model/model.js";
import { createBranchRequest, getLastIdsCustomRequest } from '@core/api/branch/branch.service';
import MoreBranchInformation from './MoreBranchInformation';
import Grid from '@mui/material/Grid2';

let moment = require('moment');
let beginningTime = null;
let endTime = null;
let validTime;
const AddBranchOffice = (props) => {
	const lan = useLanguage();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const moreBranchInformationRef = useRef({});
	const [idCustom, setIdCustom] = useState('');
	const [name, setName] = useState('');
	const [newDirection, setNewDirection] = useState('');
	const [latitude, setLatitude] = useState(0);
	const [longitude, setLongitude] = useState(0);
	const [postalCode, setPostalCode] = useState('');
	const [branchState, setBranchState] = useState('');
	const [timeZone, setTimeZone] = useState('');
	const [municipality, setMunicipality] = useState('');
	const [country, setCountry] = useState('');
	const [errorLocation, setErrorLocation] = useState(false);
	const [id, setId] = useState(null);
	const [legalAddress, setLegalAddress] = useState(null);
	const [activateAlert, setActivateAlert] = useState(false);
	const [attentionTimeFrom, setAttentionTimeFrom] = useState(null);
	const [attentionTimeTo, setAttentionTimeTo] = useState(null);
	const [showErrorDuplicateBranch, setShowErrorDuplicateBranch] = useState(false);
	const [lastIdsCustom, setLastIdsCustom] = useState([]);
	const [showMoreBranchInfo, setShowMoreBranchInfo] = useState(false);
	useEffect(() => {
		const onSuccess = (response) => {
			let branches = response.branches;
			if (branches) {
				setLastIdsCustom(branches);
			}
		}
		const onError = (error) => {
			console.log(error)
		}
		const loadingConfig = { name:"GET_LAST_IDS_CUSTOM", dispatch }
		getLastIdsCustomRequest(onSuccess, onError, loadingConfig)

		if (props.defaultCompany) {
			setId(props.defaultCompany.value.id)
		}

	}, []);
	const getCompanyList = async (event) => {
		if (event.length > 0) {
			let assignList = await getCompaniesByFilterAsyncSelectCreateTask(event);

			return assignList;
		}
	};
	const getInitialOptionsCompany = async () => {
		return await getCompaniesInitialOptionsAsyncSelect();
	};
	const updateLocation = (newLocation, coordinates) => {
		console.log('newLocation', newLocation);
		if (coordinates.lat != latitude && coordinates.lng != longitude) {
			setLatitude(coordinates.lat)
			setLongitude(coordinates.lng)
			setNewDirection(newLocation.address)
			setPostalCode(newLocation.postalCode)
			setBranchState(newLocation.state)
			setTimeZone(newLocation.timezone)
			setCountry(newLocation.country)
			setMunicipality(newLocation.municipality)
		}
	};
	const handleOptionSelected = (selectedOption) => {
		if (selectedOption == null) {
			setId(null);
		} else {
			document.getElementById('company-alert-icon').style.display = 'none';
			setId(selectedOption.value.id)
		}
	};
	const setValidateName = () => {
		if (name !== '') {
			document.getElementById('name-alert-icon').style.display = 'none';
			document.getElementById('name-red-input').style.borderColor = '#ced4da';
		}
	};
	const setFieldValue = (value, field) => {

		const sanitizedInput = sanitizeInput(value);

		if (field === 'idCustom') {
			setIdCustom(sanitizedInput)
			document.getElementById('register-form-hint').style.display = 'none';
			setShowErrorDuplicateBranch(false)
		} else if (field === 'name') {
			setName(sanitizedInput)
			setValidateName();
			document.getElementById('register-form-hint').style.display = 'none';
			setShowErrorDuplicateBranch(false)
		}
	};
	const validateIdCustom = (idCustom) => {
		if (idCustom !== '') {
			document.getElementById('idCustom-alert-icon').style.display = 'none';
			document.getElementById('id-input-branch-idCustom').style.borderColor = '#ced4da';
			return true;
		}
		document.getElementById('idCustom-alert-icon').style.display = 'inline';
		document.getElementById('id-input-branch-idCustom').style.borderColor = '#c70101';
		return false;
	};
	const validateName = (name) => {
		if (name !== '') {
			document.getElementById('name-alert-icon').style.display = 'none';
			return true;
		}
		document.getElementById('name-alert-icon').style.display = 'inline';
		document.getElementById('name-red-input').style.borderColor = '#c70101';
		return false;
	};
	const validateCompany = (id) => {
		if (id !== null) {
			document.getElementById('company-alert-icon').style.display = 'none';
			return true;
		}
		document.getElementById('company-alert-icon').style.display = 'inline';
		return false;
	};
	const validateLocation = () => {
		let isValid = latitude !== 0 && longitude !== 0 && newDirection !== ''
		setErrorLocation(!isValid)
		return isValid;
	};
	const openMoreBranchInfo = () => {
		setShowMoreBranchInfo(!showMoreBranchInfo);
	}
	const handleDoActionAddBranch = (createWithTask) => {
		const isValidName = validateName(name);
		const isValidIdCustom = validateIdCustom(idCustom);
		const isValidIdCompany = validateCompany(id);
		const isValidLocation = validateLocation();

		if (isValidName && isValidIdCustom && isValidLocation && isValidIdCompany && activateAlert === false) {

			let branchInfoPass = {
				parentCompanyId: id,
				idCustom: idCustom,
				name: name,
				state: branchState,
				country: country,
				postalCode: postalCode,
				address: newDirection,
				latitude: latitude,
				longitud: longitude,
				timeZone: timeZone,
				municipality: municipality,
				attentionTimeFrom: attentionTimeFrom,
				attentionTimeTo: attentionTimeTo,
				legalAddress: legalAddress != null && legalAddress !='' ? legalAddress : null,
				createWithDirection: true,
				nameMoreInfo: moreBranchInformationRef.current.name,
				lastNameMoreInfo: moreBranchInformationRef.current.lastName,
				emailMoreInfo: moreBranchInformationRef.current.email,
				cellphoneMoreInfo: moreBranchInformationRef.current.cellphone,
				officePhoneMoreInfo: moreBranchInformationRef.current.officePhone,
				commentMoreInfo: moreBranchInformationRef.current.comment,
			};

			document.getElementById('register-form-hint').style.display = 'none';
			let newCompanyInfo = model.doActionCreateBranch(branchInfoPass);
			const body = newCompanyInfo.data;

			const onSuccess = (response) => {
				if (createWithTask == false) {
					if(props.getBranchInformation && response.branch){
						props.getBranchInformation(response.branch);
					}
					handleClose();
				} else {
					let idBranch = response.idBranch;
					handleClose();
					navigate(`${ENDPOINTS.createTask}?branch=${idBranch}`)
				}
			}

			const onError = (response) => {
				if (response.status === ErrorCodes.DUPLICATED_BRANCH) {
					setShowErrorDuplicateBranch(true)
					document.getElementById('register-form-hint').style.display = 'inline';
				} else {
					props.errorMessageCreation();
				}
			}

			const loadingConfig = { name:"CRATE_BRANCH", dispatch }
			createBranchRequest(body, onSuccess, onError, loadingConfig)

		} else {
			document.getElementById('register-form-hint').style.display = 'inline';
		}
	};
	const onChangeTimeOne = (value) => {
		if (value != undefined) {
			let timeFrom = new Date(value._d);
			beginningTime = timeFrom;
			validateTime();
		}
	};
	const onChangeTimeTwo = (value) => {
		if (value != undefined) {
			let timeFromTo = new Date(value._d);
			endTime = timeFromTo;
			validateTime();
		}
	};
	const validateTime = () => {
		if (beginningTime != null && endTime != null) {
			let initialTime = beginningTime;
			let finalTime = endTime;
			validTime = moment(initialTime, 'h:mm a').isBefore(moment(finalTime, 'h:mm a'));
			if (validTime == true) {
				let formatInitialTime = moment(initialTime, 'hh:mm a').format('HH:mm');
				let formatEndTime = moment(finalTime, 'hh:mm a').format('HH:mm');
				setAttentionTimeFrom(formatInitialTime)
				setAttentionTimeTo(formatEndTime)
				setActivateAlert(false)
			} else {
				setActivateAlert(true)
			}
		}
	};
	const handleClose = () => {
		props.setDefaultFalse();
	};
	return (<>
		<div className='px-4 mt-2' style={{ height: '100%' }}>
			<div className='mb-4'>
				<div className='col-sm-12 Fielder-cards-txt-label-input'>
					{lan.idCustomBranch}
				</div>
				<div className='col-sm-12 font-inputs'>
					<div className='input-group input-group-sm mb-3'>
						<div className='input-group-prepend' />
						<input
							id='id-input-branch-idCustom'
							type='text'
							className='form-control Fielder-cards-font-inputs'
							aria-label='Small'
							value={idCustom}
							aria-describedby='inputGroup-sizing-sm'
							onChange={(e) => setFieldValue(e.target.value, 'idCustom')}
						/>
						<img
						src={redAlertIcon}
						alt=''
						id='idCustom-alert-icon'
						className='CreateTask-idCustom-icon'

						/>
					</div>
				</div>
			</div>

		{ lastIdsCustom && lastIdsCustom.length >0 &&(
			<div className='mb-4'>
				<div className='col-sm-12 Fielder-cards-txt-label-input'>
					{lan.lastIdsCustomUsed}
				</div>

				<div className='col-sm-12 font-inputs'>
					<div className='input-group input-group-sm mb-3'>
						<div className='input-group-prepend' />
						{lastIdsCustom.map((data) => (
							<Chip
								className='mx-2 my-1'
								key={data.id}
								label={data.idCustom}
							/>
						))}
					</div>
				</div>
			</div>
		)}

			<div className='mb-4'>
				<div className='col-sm-12 Fielder-cards-txt-label-input'>
					{lan.branchNameText}
				</div>
				<div className='col-sm-12 font-inputs'>
					<div className='input-group input-group-sm mb-3'>
						<div className='input-group-prepend' />
						<input
							type='text'
							className='form-control Fielder-cards-font-inputs'
							aria-label='Small'
							id='name-red-input'
							value={name}
							aria-describedby='inputGroup-sizing-sm'
							onChange={(e) => setFieldValue(e.target.value, 'name')}
						/>
					</div>
					<img
						src={redAlertIcon}
						alt=''
						id='name-alert-icon'
						className='CreateTask-nameContainer-icon'
					/>
				</div>

				{showErrorDuplicateBranch && (
					<div className='alert alert-warning' role='alert' id='showAlert'>
						{lan.idCustomBranchDuplicated}
					</div>
				)}
			</div>

			<div className='mb-4'>
				<div className='col-sm-12 Fielder-cards-txt-label-input'>
					{lan.rangeOfAttentionTime}
				</div>
				<div className='col-sm-12'>
					{activateAlert && (
						<div className='alert alert-warning' role='alert' id='showAlert'>
							{lan.hourValidation}
						</div>
					)}

					<div className='row mx-auto justify-content-center'>
						<div className='col-6'>
							<Datetime
								id='id-date-from'
								inputProps={{ placeholder: lan.from, readOnly: true }}
								dateFormat={false}
								onChange={onChangeTimeOne}
							/>
						</div>

						<div className='col-6'>
							<Datetime
								id='id-date-to'
								inputProps={{ placeholder: lan.to, readOnly: true }}
								dateFormat={false}
								onChange={onChangeTimeTwo}
							/>
						</div>
					</div>
				</div>
			</div>

			<div className='mb-4'>
				<div className='col-sm-12 Fielder-cards-txt-label-input'>
					{lan.companyBranch}
				</div>

				<div className='col-sm-12 font-inputs'>
					<AsyncSearch
						className='id-select-branch-company full-width'
						getOptions={(e) => getCompanyList(e)}
						onChange={(e) => handleOptionSelected(e)}
						label={lan.placeHolderCompany}
						id='id-select-branch-company'
						showInitialOptions
						getInitialOptions={getInitialOptionsCompany}
						defaultValue={props.defaultCompany ? props.defaultCompany : null	}
					/>

					<img
						src={redAlertIcon}
						alt=''
						id='company-alert-icon'
						className='CreateTask-nameContainer-icon'
					/>
				</div>
			</div>

			<div className='mt-3 mb-4'>
				<div className='col-sm-12 Fielder-cards-txt-label-input' />

				<Location
					edit
					includeCoordinates
					label={lan.branchLocation}
					locationUpdate={updateLocation}
					error={errorLocation}
					coordinates={{
						lat: latitude,
						lng: longitude,
					}}
				/>
			</div>

			<div className='mt-2 mb-4'>
				<div className='col-sm-12 Fielder-cards-txt-label-input'>
					{lan.legalAddress}
				</div>
				<div className='col-sm-12'>
					<input
						id='id-input-branch-legalAddress'
						placeholder={lan.legalAddress}
						type='text'
						className='form-control Fielder-cards-font-inputs'
						value={legalAddress}
						onChange={(e) => setLegalAddress(value => sanitizeInput(e.target.value)) }
					/>
				</div>
			</div>
      <Grid container>
        <Grid size={12} className='branch-label-input mt-2'>
        <span
          onClick={openMoreBranchInfo}
          style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}
        >
          {lan.moreInformation}
        </span>
        </Grid>
        <Grid size={12}>
          <MoreBranchInformation
            showMoreBranchInfo={showMoreBranchInfo}
            ref={moreBranchInformationRef}
            nameValue={null}
            lastNameValue={null}
            emailValue={null}
            cellphoneValue={null}
            officePhoneValue={null}
            legalAddressValue={null}
            editData={true}
          />
        </Grid>
      </Grid>
			<div id='register-form-hint' className='Register-form-hint mt-3'>
				<p>*{lan.requiredFields}</p>
			</div>

			<div className='mb-3 mt-5'>
				<div className='row'>
					<div className='col-6 d-flex justify-content-center'>
						<button
							id='id-input-branch-add-button'
							type='submit'
							className='btn btn-outline-primary btn-success  Add-branch-office-btn-center Add-branch-office-btn-size'
							onClick={() => handleDoActionAddBranch(false)}
						>
							{lan.addBranch}
						</button>
					</div>
					{props.showCreateBranchWithTask && (
						<div className='col-6 d-flex justify-content-center'>
							<button
								id='id-input-branch-add-button'
								type='submit'
								className='btn btn-outline-primary btn-success  Add-branch-office-btn-center Add-branch-office-btn-size'
								onClick={() => handleDoActionAddBranch(true)}
							>
								{lan.addBranchAndCreateTask}
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	</>);
}
export default AddBranchOffice;
*/
